import { NormalPeoplePickerBase } from '@fluentui/react/lib/Pickers';
import { IPersonaProps } from '@fluentui/react/lib/Persona';
export class CustomPicker extends NormalPeoplePickerBase {
    public refreshSuggestions(suggestions: IPersonaProps[]): void {
        this.updateSuggestions(suggestions);
    }
}
